import React from 'react';

interface IconProps {
    children?: React.ReactNode;
    className?: string;
    size?: 'small' | 'medium' | 'large' | number;
    color?: string;
    onClick?: (event: React.MouseEvent<HTMLSpanElement>) => void;
    title?: string;
}

const Icon: React.FC<IconProps> = ({ children, className = '', size = 'medium', color, onClick, title }) => {
    const baseClass = 'idsk-icon';

    // Convert size to pixel value if it's a string
    let sizeValue: number | string = size;
    if (typeof size === 'string') {
        switch (size) {
            case 'small':
                sizeValue = 16;
                break;
            case 'medium':
                sizeValue = 24;
                break;
            case 'large':
                sizeValue = 32;
                break;
        }
    }

    // Apply size and color to children if they are SVG elements
    const styledChildren = React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                width: sizeValue,
                height: sizeValue,
                color: color,
                ...child.props,
            });
        }
        return child;
    });

    return (
        <span
            className={`${baseClass} ${className}`.trim()}
            onClick={onClick}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : undefined}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: color,
            }}
            title={title}
        >
      {styledChildren}
    </span>
    );
};

export default Icon;
